import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel';

(function () {
    $(".owl-carousel.testimonials-slider-2").owlCarousel({
        items: 1,
        loop: true,
        center: false,
        autoplay: true,
        autoplayHoverPause: true,
        dots: true,
        mouseDrag: true,
        touchDrag: true,
        slideTransition: 'linear'
    });

    $(".owl-carousel.images-slider").owlCarousel({
        items: 1,
        loop: true,
        center: false,
        autoplay: true,
        autoplayHoverPause: true,
        dots: false,
        nav: true,
        mouseDrag: true,
        touchDrag: true,
        slideTransition: 'linear'
    });

    $('.builder-element__3columns--upload [data-file]').css('cursor', 'pointer');
    $('.builder-element__3columns--upload [data-file]').on('click', function () {
        document.location = $(this).data('file');
    });
}());
